import React from "react";
import Hero from "./Hero";
import Platform from "./Platform";
import Offering from "./Offering";
import Client from "./Client";

const Home = () => {
  return (
    <>
      <Hero />
      <Platform />
      <Offering />
      <Client />
    </>
  );
};

export default Home;
